import Redirect from './Redirect';

export default {
  install(Vue) {
    Vue.use(Redirect);
  },
};
